import React from 'react';

const InlineLoadingBar = () => {
	return (
		<div className="h-[10px] w-[40px] rounded-[5px] border border-text-default p-px">
			<div className="h-full animate-loading-bar rounded-[5px] bg-text-default" />
		</div>
	);
};

export default InlineLoadingBar;
